import { Line } from "react-chartjs-2";
import {
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Legend,
  Tooltip,
  Title,
  LineElement,
  PointElement,
} from "chart.js";
import { hejriDate } from "@helpers/financial_helper";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Chart = ({ chartChillingData }) => {
  let sum = 0;
  let arrayPointYData = [];
  let arrayPointXData = [];

  chartChillingData?.dailyUtahNumbers?.forEach((item) => {
    sum += item?.utahNumber;
    arrayPointXData.push(hejriDate(item?.date));
    arrayPointYData.push(sum);
  });

  const data = {
    labels: arrayPointXData,
    datasets: [
      {
        data: arrayPointYData,
        label: "واحد سرمایی",
        showBox: false,
        borderWidth: 2,
        fill: false,
        borderColor: "#460F81",
        drawActiveElementsOnTop: true,
        showLine: true,
        tension: 0,
        pointRadius: 0, // حذف نقاط
      },
    ],
  };

  const options = {
    elements: {
      point: {
        radius: 0, // Set the radius of the data points
        hoverRadius: 4, // Set the radius of the data points on hover
        hitRadius: 5, // Set the radius for determining if the point is hovered
      },
    },
    plugins: {
      datalabels: {
        display: false, // حذف labelهای روی نقاط داده‌ای
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "نمودار تجمع واحد سرمایی در قطعه زمین شما",
        font: {
          size: 18, // optional font size
          family: "Arial", // optional font family
          weight: "bold", // optional font weight
        },
        color: "#333", // optional font color
      },
      tooltip: {
        titleFont: {
          family: "IRANSansX", // Set the font family for the tooltip title
          size: 14, // Set the font size for the tooltip title
        },
        bodyFont: {
          family: "IRANSansX", // Set the font family for the tooltip body
          size: 14, // Set the font size for the tooltip body
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          font: {
            family: "IRANSansX", // Set the font family for the x axis title
            size: 14, // Set the font size for the x axis title
          },
        },
        ticks: {
          font: {
            family: "IRANSansX", // Set the font family for the x axis ticks
            size: 12, // Set the font size for the x axis ticks
          },
        },
      },
      y: {
        title: {
          font: {
            family: "IRANSansX", // Set the font family for the y axis title
            size: 14, // Set the font size for the y axis title
          },
        },
        ticks: {
          font: {
            family: "IRANSansX", // Set the font family for the y axis ticks
            size: 12, // Set the font size for the y axis ticks
          },
        },
      },
    },
  };

  return (
    <div className="w-[710px] flex items-center justify-center px-4">
      <Line data={data} options={options} width={"720px"} height={"340px"} />
    </div>
  );
};

export default Chart;
